<template>
    <request-products :multiple-products="false" :loader="isShowLoader" :on-next="fetchRequestFields" :tariff="tariff"
        :balance="requestBalance" :individualProducts="individualProducts" :legalProducts="legalProducts"
        @tariff-closed="fetchProducts" />
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import RequestProducts from "./RequestProducts.vue";

export default {
    name: 'request-products-container',
    components: {
        RequestProducts,
    },
    data() {
        return {
            productsIsFetched: false,
            tariffIsFetched: false,
        }
    },
    methods: {
        ...mapActions('balance', ['fetchBalance']),
        ...mapActions('profileTariff', ['fetchProfileTariff']),
        ...mapActions('request', ['fetchAvailableProducts', 'fetchRequestFields', 'fetchProfile']),
        ...mapActions('regions', ['fetchRegions']),

        fetchProducts() {
            this.productsIsFetched = false;
            return this.fetchAvailableProducts().then(() => {
                this.productsIsFetched = true;
            });
        },
    },
    created() {
        this.fetchProfileTariff()
            .then(({ data }) => {
                this.tariffIsFetched = true;
            })
            .catch(() => {
                this.tariffIsFetched = true;
            });

        this.fetchProducts();

        this.fetchProfile();

        if (!this.regions.length) {
            this.fetchRegions();
        }
    },
    computed: {
        ...mapGetters('profileTariff', {
            tariff: 'tariff',
            tariffBalance: 'balance',
        }),
        ...mapGetters('request', ['products', 'groups']),
        ...mapGetters('balance', ['balance']),
        ...mapGetters('regions', ['regions']),

        requestBalance() {
            return this.hasTariff ? this.tariffBalance : this.balance;
        },

        hasTariff() {
            return this.tariff && !!this.tariff.title;
        },

        customProducts() {
            const customProduct = {
                id: -1,
                name: 'Анализ КИ',
                cost: 0,
                isIndividual: true,
                isEnable: true,
                freeCount: 0,
                description: 'Анализ кредитной истории'
            };

            return [customProduct, ...this.products];
        },

        productsByIndividual() {
            return this.customProducts.reduce((newProducts, product) => {
                if (product.isIndividual) {
                    newProducts.individualProducts.push(product);
                } else {
                    newProducts.legalProducts.push(product);
                }

                return newProducts;
            }, {
                individualProducts: [],
                legalProducts: [],
            });
        },

        individualProducts() {
            return this.productsByIndividual.individualProducts;
        },

        legalProducts() {
            return this.productsByIndividual.legalProducts;
        },

        isShowLoader() {
            return !this.tariffIsFetched || !this.productsIsFetched;
        }
    }
}
</script>



// WEBPACK FOOTER //
// RequestProductsContainer.vue?c79642a2